import { ListEntry } from "./types/port-view-model.types";
import { TerminalInfo } from "./types/terminals-model.types";

export abstract class PortViewModelBase extends EventTarget {
    abstract unLocode2Rkst: Map<string, string>;
    abstract get traffic(): ListEntry[];
    abstract get terminals(): TerminalInfo[];
    abstract setOclAndPort(ocl?: string, port?: string): void;
    abstract stopFetchingData(): void;
}

let PortViewModel: PortViewModelBase|null = null;

function setPortViewModel(model: PortViewModelBase)
{
    PortViewModel = model;
}

export { PortViewModel, setPortViewModel };
